import styled from "styled-components";

import { FlexDiv } from "@/components/Atoms/Box";

import Typography from "@/foundation/Typography/V2";
import theme from "@/foundation/Theme";

export const PollProgressBars = styled(FlexDiv)`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-row-gap: 8px;
  grid-column-gap: 16px;
  @media only screen and (max-width: 1000px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const PollProgressBarWrapper = styled(FlexDiv)`
  position: relative;
  height: 46px;
  width: 100%;
  max-width: 450px;
  border-radius: 16px;
  overflow: hidden;
  cursor: pointer;
`;

export const ProgressBar = styled(FlexDiv)`
  width: 100%;
  background: #e5f0f5;
`;

export const ProgressValue = styled(FlexDiv)`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  background: #86ceef;
`;

export const Option = styled(Typography)`
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  font-family: var(--man);
  font-weight: 600;
  font-size: 15px;
  line-height: 22px;
  letter-spacing: 0.01em;
  color: #293056;
`;

export const Percentage = styled(Typography)`
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  font-family: var(--man);
  font-weight: 600;
  font-size: 15px;
  line-height: 22px;
  letter-spacing: 0.01em;
  color: #293056;
`;

export const PollMetaWrapper = styled(FlexDiv)``;

export const NumberOfVotes = styled(Typography)`
  font-family: var(--man);
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  text-transform: capitalize;
  color: #344054;
`;

export const MidDot = styled(Typography)`
  font-size: 20px;
  margin: 0 4px;
  color: #98a2b3;
`;

export const PollTimeRemaining = styled(Typography)`
  font-family: var(--man);
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  color: #667085;
`;
